<template>
    <v-menu offset-y v-model="menuValue">
        <template v-slot:activator="{ on }">
            <div class="d-block mx-6">
                <v-icon 
                    v-on="on" 
                    :class="{ active: menuValue }" 
                    @click="$emit('click')">
                        mdi-chevron-right
                </v-icon>
            </div>
        </template>
    </v-menu>
</template>

<script>

/**
 * ExpansionButton is a simple component that includes the defined icon to the 
 * menu button.
 */
export default {
    name: 'ExpansionButton',
    data: () => ({
        menuValue: null
    })
};
</script>

<style scoped>
.v-icon.active  {
    transform: rotate(-180deg);
}
</style>